import { render, staticRenderFns } from "./FileUploadV2.vue?vue&type=template&id=4e2fad1a&scoped=true"
import script from "./FileUploadV2.vue?vue&type=script&lang=js"
export * from "./FileUploadV2.vue?vue&type=script&lang=js"
import style0 from "./FileUploadV2.vue?vue&type=style&index=0&id=4e2fad1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fad1a",
  null
  
)

export default component.exports